const WRAPPER_SELECTOR = ".hero__media-wrapper";
const CONTROLS_SELECTOR = "[data-hero-video-controls]";
const VP_BUTTON_SELECTOR = ".vp-video-control-button";

function getHero(element) {
  return element.closest(".hero");
}

function updateStates(wrapper, video) {
  if (!wrapper || !video) return;

  const isPlaying = !video.paused && !video.ended;
  const isMuted = video.muted || video.volume === 0;

  wrapper.classList.toggle("hero-video--playing", isPlaying);
  wrapper.classList.toggle("hero-video--paused", !isPlaying);
  wrapper.classList.toggle("hero-video--muted", isMuted);
  wrapper.classList.toggle("hero-video--unmuted", !isMuted);

  const controls = wrapper.querySelector(CONTROLS_SELECTOR);
  if (!controls) return;

  const playPauseButton = controls.querySelector('[data-hero-video-toggle="play-pause"]');
  const muteButton = controls.querySelector('[data-hero-video-toggle="mute"]');

  if (playPauseButton) {
    playPauseButton.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
  }

  if (muteButton) {
    muteButton.setAttribute("aria-label", isMuted ? "Unmute video" : "Mute video");
  }

  const hero = getHero(wrapper);
  if (hero) {
    const anyPlaying = hero.querySelector(".hero__media-wrapper--video.hero-video--playing");
    hero.classList.toggle("hero--video-playing", Boolean(anyPlaying));

    const vpButton = hero.querySelector(VP_BUTTON_SELECTOR);
    if (vpButton) {
      vpButton.classList.toggle("vp-video-control-button--hidden", Boolean(anyPlaying));
    }
  }
}

function initWrapper(wrapper) {
  if (!wrapper || wrapper.dataset.heroVideoInitialized === "true") return;

  const video = wrapper.querySelector("video");
  const controls = wrapper.querySelector(CONTROLS_SELECTOR);

  if (!video || !controls) return;

  try {
    // Ensure videos start in a paused state on load
    video.pause();
  } catch {
    // Ignore pause errors
  }

  wrapper.dataset.heroVideoInitialized = "true";

  const playPauseButton = controls.querySelector('[data-hero-video-toggle="play-pause"]');
  const muteButton = controls.querySelector('[data-hero-video-toggle="mute"]');

  if (playPauseButton) {
    playPauseButton.addEventListener("click", () => {
      const vpButton = wrapper.querySelector(VP_BUTTON_SELECTOR);
      if (vpButton) {
        vpButton.classList.toggle("vp-video-control-button--hidden");
      }
      try {
        if (video.paused || video.ended) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      } catch {
        // Ignore playback errors
      } finally {
        updateStates(wrapper, video);
      }
    });
  }

  if (muteButton) {
    muteButton.addEventListener("click", () => {
      video.muted = !video.muted;
      if (!video.muted && video.volume === 0) {
        video.volume = 1;
      }
      updateStates(wrapper, video);
    });
  }

  video.addEventListener("play", () => updateStates(wrapper, video));
  video.addEventListener("pause", () => updateStates(wrapper, video));
  video.addEventListener("volumechange", () => updateStates(wrapper, video));

  updateStates(wrapper, video);
}

function initVpButtons() {
  const buttons = document.querySelectorAll(VP_BUTTON_SELECTOR);

  buttons.forEach((button) => {
    if (button.dataset.heroVideoVpInitialized === "true") return;

    button.dataset.heroVideoVpInitialized = "true";

    button.addEventListener("click", () => {
      const hero = getHero(button);
      if (!hero) return;

      const wrappers = hero.querySelectorAll(".hero__media-wrapper--video");

      wrappers.forEach((wrapper) => {
        const video = wrapper.querySelector("video");
        if (!video) return;

        try {
          if (video.paused || video.ended) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        } catch {
          // Ignore playback errors
        } finally {
          updateStates(wrapper, video);
        }
      });
    });
  });
}

function initAll() {
  const wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
  wrappers.forEach(initWrapper);
  initVpButtons();
}

function resetHeroVideosAfterBfcacheRestore() {
  const heroes = document.querySelectorAll(".hero");

  heroes.forEach((hero) => {
    const wrappers = hero.querySelectorAll(`${WRAPPER_SELECTOR}.hero__media-wrapper--video`);

    wrappers.forEach((wrapper) => {
      const video = wrapper.querySelector("video");
      if (!video) return;

      try {
        video.pause();
        video.muted = true;
        if (video.volume === 0) {
          video.volume = 1;
        }
        video.load();
      } catch {
        // Ignore reset errors
      }
    });

    wrappers.forEach((wrapper) => {
      const video = wrapper.querySelector("video");
      if (!video) return;
      updateStates(wrapper, video);
    });
  });
}

if (!window.__heroVideoControlsInitialized) {
  window.__heroVideoControlsInitialized = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      resetHeroVideosAfterBfcacheRestore();
    }
  });

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:select", initAll);
}
